'use strict';

var _classCallCheck = require("/home/keoadmin/agent/_work/107/s/node_modules/@babel/runtime/helpers/classCallCheck.js");
var _createClass = require("/home/keoadmin/agent/_work/107/s/node_modules/@babel/runtime/helpers/createClass.js");
var _inherits = require("/home/keoadmin/agent/_work/107/s/node_modules/@babel/runtime/helpers/inherits.js");
var _possibleConstructorReturn = require("/home/keoadmin/agent/_work/107/s/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
var _getPrototypeOf = require("/home/keoadmin/agent/_work/107/s/node_modules/@babel/runtime/helpers/getPrototypeOf.js");
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Container = require('./container');
var list = require('./list');
var Rule = /*#__PURE__*/function (_Container) {
  _inherits(Rule, _Container);
  var _super = _createSuper(Rule);
  function Rule(defaults) {
    var _this;
    _classCallCheck(this, Rule);
    _this = _super.call(this, defaults);
    _this.type = 'rule';
    if (!_this.nodes) _this.nodes = [];
    return _this;
  }
  _createClass(Rule, [{
    key: "selectors",
    get: function get() {
      return list.comma(this.selector);
    },
    set: function set(values) {
      var match = this.selector ? this.selector.match(/,\s*/) : null;
      var sep = match ? match[0] : ',' + this.raw('between', 'beforeOpen');
      this.selector = values.join(sep);
    }
  }]);
  return Rule;
}(Container);
module.exports = Rule;
Rule.default = Rule;
Container.registerRule(Rule);